import { TFunction } from 'i18next';

export type RiskWarningsTranslations = {
  riskWarning1: string;
  riskWarning2: string;
  riskWarningTakeMinutes: string;
};

export const riskWarning: RiskWarningsTranslations = {
  riskWarning1: 'risk_warning_1',
  riskWarning2: 'risk_warning_2',
  riskWarningTakeMinutes: 'risk_warning_take_minutes',
};

export const getRiskWarningsTranslations = (
  t: TFunction,
): RiskWarningsTranslations => {
  return Object.entries(riskWarning).reduce((acc, [key, value]) => {
    acc[key as keyof RiskWarningsTranslations] = t(value);

    return acc;
  }, {} as RiskWarningsTranslations);
};
